// MATERIAL UI
import { Box, Typography } from "@mui/material";

interface ITradeErrorProps {
  message?: string;
}
export const TradeError = ({ message }: ITradeErrorProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap="8px"
      padding="12px"
      borderRadius="10px"
      bgcolor="#FFF6F6">
      <Typography fontFamily="Roobert" fontSize="14px" lineHeight="16px" color="#002035">
        {message}
      </Typography>
    </Box>
  );
};
